import App from '../../App'
import {html, render } from 'lit-html'
import {gotoRoute, anchorRoute} from '../../Router'
import Auth from '../../Auth'
import Utils from '../../Utils'
import UserAPI from '../../UserAPI'
import Toast from '../../Toast'

class proSignUpView {
  init(){      
   
    document.title = 'Professional Sign Up'    
    this.render()
    Utils.pageIntroAnim()
    
  }


  

  signUpSubmitHandler(e){
    e.preventDefault()    
    const submitBtn = document.querySelector('.submit-btn')
    submitBtn.setAttribute('loading', '')    
    const formData = e.detail.formData
    
    // sign up using Auth
    Auth.signUp(formData, () => {
      submitBtn.removeAttribute('loading')
    })   
  }

  render(){
    const template = html`      

    <div class="signuppage">



    <div class="proimagebox">
    
    <div id="signupoverlay" class="animate__animated animate__fadeInLeft">
          <h2  style="font-size:16px; font-weight:700; color: #FFFFFF; "> <span style=" color: #FFA132;">PROFESSIONAL</span> SIGN UP</h2>


          <div class="signupoverlaytxt">
          <h1 class="signtitles" style="color:#FFA132; "  >Just starting out?<br>Struggling to find work?</h1>
          <p class="signtxt" >Let’s get you set up and we’ll help you find clients at the snap of a finger.</p>
          </div>
          </div>
    
    
    
    
    
    
    
    </div>

    
    <div  class="signup-box">

              <div>
          
                  <h2>Tell us a bit about yourself.</h2>
              </div>

          <sl-form class="form-signup" @sl-submit=${this.signUpSubmitHandler}> 


            <div class="container">
                      
              
              
              
              
            
                  <div class="column">
                  
                  <div class="input-group-signup">
   
                  <sl-input label="Name" name="firstName" type="text" placeholder="Name" required></sl-input>
                </div>
      
                <div class="input-group-signup">
               
                  <sl-input label="Surname" name="lastName" type="text" placeholder="Surname" required></sl-input>
                </div>
      
      
                <div class="input-group-signup">
                    <sl-input label="Email" name="email" type="email" placeholder="example@something.com" required></sl-input>
                </div>
      
                <div class="input-group-signup">
                  <sl-input name="password" label="Password" type="password" placeholder="************" required toggle-password ></sl-input>
                </div>
      
               
      
               
      
                <div class="input-group-signup">
                
                    <sl-input name="confirmpassword" label="Confirm Password" type="password" placeholder="************"toggle-password required></sl-input>
      
                </div>
      
      
                  
                  
                  
                  
                  </div>




                  <div class="column">
                  
                  

                  <div class="input-group-signup">
   
                          <sl-input label="Phone Number" name="phone" type="text" placeholder="+230 5123 1234"  ></sl-input>
                        </div>

                        <div class="input-group-signup">
                        
                          <sl-input label="Address" name="address" type="text" placeholder="Address"  ></sl-input>
                        </div>
                  
                  
                  
                  
                  
                  </div>
          
          
          

      
        
            </div> <br><br>
      
      <sl-button  name="accessLevel" type="primary" value="2" class="submit-btn" submit style="width: 40%; margin-top: .5em;">GOOD TO GO</sl-button>


      

    </div>



 </sl-form>
</div>

   




    `
    render(template, App.rootEl)
  }
}


export default new proSignUpView()